export default __webpack_public_path__ + "src/assets/images/payment-expired.webp";
export const Scaled = {
    "0.5x": __webpack_public_path__ + "src/assets/images/payment-expired.webp",
    "1x": __webpack_public_path__ + "src/assets/images/payment-expired.webp",
    "2x": __webpack_public_path__ + "src/assets/images/payment-expired.webp",
    "3x": __webpack_public_path__ + "src/assets/images/payment-expired.webp",
    "4x": __webpack_public_path__ + "src/assets/images/payment-expired.webp"
}